import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { bool, func, string } from 'prop-types';
import React from 'react';
import { postRequest } from '../api-client';
/**
 * This is an abstract render props component for logging in with social accounts. The component adds two items to scope: `serverSideLoginPath` for redirecting to server side, and `login` for doing a client side login. Calling `login()` returns a promise which can be used to handle success and failure cases.
 *
 * This component should not be used directly, but should be used via one of the scomponents mentioned in the example.
 *
 * Please contact the support in order to update the social app credentials in the Bridgekeeper database after making the relevant code changes.
 *
 * NOTE:
 * - Twitter and LinkedIn do not support ClientSideLogin, and thus `login()` will just redirect to the server. It also ignores the apiKey
 * - Twitter and LinkedIn do not verify presence of email on the client side. Please ask for these permissions in the app
 * - The `login()` need not be called when serverSideLoginPath is called
 *
 *
 * Example
 * ```javascript
 * import { WithFacebookLogin, WithGoogleLogin, WithTwitterLogin, WithLinkedInLogin } from '@quintype/components';
 *
 * function socialLogin(e, login) {
 *   e.preventDefault();
 *   login().then(() => window.location.refresh()); // Can also make an API call to /api/v1/members/me
 * }
 *
 * <WithFacebookLogin appId="apiKey" scope="email" emailMandatory>{({ login, serverSideLoginPath }) =>
 *     <a href={serverSideLoginPath} onClick={e => socialLogin(e, login)}>
 *       <img src={assetify(facebookIcon)} />
 *     </a>
 * }</WithFacebookLogin>
 * <WithGoogleLogin clientId="clientId" scope="email" emailMandatory isBridgekeeperLogin={true}>{({ login, serverSideLoginPath }) =>
 *     <a href={serverSideLoginPath} onClick={e => socialLogin(e, login)}>
 *       <img src={assetify(gplusIcon)} />
 *     </a>
 * }</WithGoogleLogin>
 * <WithTwitterLogin apiKey="apiKey" emailMandatory>{({login, serverSideLoginPath}) =>
 *     <a href={serverSideLoginPath} onClick={e => socialLogin(e, login)}>
 *       <img src={assetify(twitterIcon)} />
 *     </a>
 * }</WithTwitterLogin>
 * <WithLinkedInLogin clientKey="clientKey" emailMandatory>{({login, serverSideLoginPath}) =>
 *     <a href={serverSideLoginPath} onClick={e => socialLogin(e, login)}>
 *       <img src={assetify(linkedInIcon)} />
 *     </a>
 * }</WithLinkedInLogin>
 * ```
 * @component
 * @hideconstructor
 * @category Login
 */

export var WithSocialLogin = /*#__PURE__*/function (_React$Component) {
  _inherits(WithSocialLogin, _React$Component);

  var _super = /*#__PURE__*/_createSuper(WithSocialLogin);

  function WithSocialLogin(props) {
    var _this;

    _classCallCheck(this, WithSocialLogin);

    _this = _super.call(this, props);
    _this.bridgekeeperServerLoginPath = "/api/auth/v1/login?auth-provider=".concat(_this.props.provider, "&redirect-url=").concat(_this.props.redirectUrl ? _this.props.redirectUrl : global.location && global.location.origin);
    _this.defaultServerLoginPath = "/login?auth-provider=".concat(_this.props.provider, "&remote-host=").concat(global.location && global.location.origin);
    _this.serverLoginPath = _this.props.isBridgekeeperLogin ? _this.bridgekeeperServerLoginPath : _this.defaultServerLoginPath;
    _this.serverSideSSOLoginPath = "/login?auth-provider=".concat(_this.props.provider, "&redirect-url=").concat(_this.props.sso && _this.props.redirectUrl ? _this.props.redirectUrl : global.location && global.location.origin);
    return _this;
  }

  _createClass(WithSocialLogin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.initialize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.children({
        login: function login(props) {
          return _this2.props.socialLogin.call(_this2, props).then(function (token) {
            return createSession(_this2.props.provider, token);
          });
        },
        serverSideLoginPath: this.props.sso ? this.serverSideSSOLoginPath : this.serverLoginPath
      });
    }
  }]);

  return WithSocialLogin;
}(React.Component);

function createSession(provider, token) {
  return postRequest("/api/login/".concat(provider), {
    token: token,
    'set-session': true
  }).json(function (r) {
    return r;
  });
}

WithSocialLogin.defaultProps = {
  initialize: function initialize() {},
  // function is rebound in WithSocialLogin
  socialLogin: function socialLogin() {
    var url = this.props.sso ? this.serverSideSSOLoginPath : this.serverLoginPath;
    window.location = url;
    return Promise.reject('EXPECT_REDIRECT');
  },
  sso: false,
  isBridgekeeperLogin: false
};